import { AnalyticsEvents, trackEvent } from "@axqora/analytics";
import type { LandingContent, Locale } from "../content/types";
import { localeHref } from "../i18n/routes";
import { Container } from "../components/Container";
import { Icon } from "../components/Icon";

type PrivacySectionProps = {
  content: LandingContent["privacy"];
  locale: Locale;
};

export function PrivacySection({ content, locale }: PrivacySectionProps) {
  return (
    <section className="bg-bg-primary py-20 lg:py-24">
      <Container>
        <div className="flex flex-col items-start gap-10 rounded-[30px] border border-subtle bg-gradient-to-br from-[#13203A] to-bg-card p-8 shadow-card md:flex-row md:items-center md:p-12">
          <div className="flex flex-col gap-4">
            <h2 className="font-display text-2xl font-bold text-text-primary sm:text-3xl">{content.title}</h2>
            <p className="text-base leading-relaxed text-text-secondary">{content.body}</p>
            <a
              href={localeHref(locale, "privacy")}
              className="mt-1 inline-flex items-center gap-1.5 text-[15px] font-semibold text-accent-blue hover:underline"
              onClick={() =>
                trackEvent(AnalyticsEvents.PrivacyClick, {
                  product: "luxoria",
                  page: "landing",
                  locale,
                  target: "privacy_section"
                })
              }
            >
              {content.linkText}
              <Icon name="arrow-right" size={16} />
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}
